/* global axios */
import ApiClient from '../ApiClient';

class StudioDocument extends ApiClient {
  constructor() {
    super('ai/documents', { accountScoped: true });
  }

  get({ page = 1, agentId } = {}) {
    return axios.get(this.url, {
      params: {
        page,
        agent_id: agentId,
      },
    });
  }

  uploadFile({ file, agentId, name }) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('agent_id', agentId);
    if (name) formData.append('name', name);
    return axios.post(this.url, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  getFirecrawlConfig() {
    return axios.get(`${this.url}/firecrawl_config`);
  }

  getEmbeddingAccess() {
    return axios.get(`${this.url}/embedding_access`);
  }

  updateFirecrawlConfig(apiKey) {
    return axios.post(`${this.url}/update_firecrawl_config`, {
      api_key: apiKey,
    });
  }
}

export default new StudioDocument();
